__turbopack_context__.v({
  "container": "Topic-module-scss-module__JKptBa__container",
  "image": "Topic-module-scss-module__JKptBa__image",
  "imageContainer": "Topic-module-scss-module__JKptBa__imageContainer",
});
